export default __webpack_public_path__ + "static/media/SphereCoreLife.f58335e7.webp";